export default class GoogleMap {


    // TODO FUTURE - remove all jQuery related code

    constructor(selector) {
        let _this = this;

        this.$plugin = $(selector);
        this.$config = this.$plugin.data('google-map-config');

        _this.initialize();
    }


    initialize() {
        let _this = this;
        _this.setPin();
        _this.attachtToContainer($('[' + _this.$config['attachedTo'] + ']'));
        _this.loadScript(_this.$config['mapsApiKey']);
    }


    initMap() {
        let _this = this;

        if (!this.$config['lat'] && !this.$config['lng']) {
            _this.removeContainer($('[' + _this.$config['attachedTo'] + ']'));
            return;
        }

        const latlng = new google.maps.LatLng(this.$config['lat'], this.$config['lng']);

        let mapOptions = {
            zoom: this.$config['zoomLevel'],
            center: latlng,
            scrollwheel: false,
            disableDefaultUI: this.$config['disableDefaultUI'],
        };

        // Create the map
        _this.map = new google.maps.Map(document.getElementById(this.$config['id']), mapOptions);
        _this.enable();

        // Info window content
        if (this.$config['showRouteUrl']) {
            _this.googleMapsRouteAnchor = _this.getGoogleRoute();
        }


        let contentString = '<div class="c-map__info-window" style="text-align: left;"><p>'
            + this.$config['street']
            + '<br>'
            + this.$config['postalcode']
            + ' ' + this.$config['city']
            + '<br></p><p>'
            + _this.googleMapsRouteAnchor
            + '</p></div>';

        var marker = new google.maps.Marker({
            position: latlng,
            map: _this.map,
            icon: this.pin
        });

        // Open the info window of the marker without clicking on marker

        if (this.$config['showInfoWindowByDefault']) {
            _this.showInfoWindowWithoutEvent(marker, contentString);
        }

        _this.addInfoWindow(marker, contentString);
        _this.map.setCenter(latlng);

        // Enable Scrolling With Mouse Wheel when clicking map
        google.maps.event.addListener(_this.map, 'mousedown', function () {
            _this.enableScrollingWithMouseWheel()
        });

        google.maps.event.addDomListener(window, 'resize', function () {
            _this.map.setCenter(latlng);
        });
    }


    loadScript($key, debug = false) {

        let _this = this;

        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + $key, function (data, textStatus, jqxhr) {
            if (debug) {
                console.log(data); // Data returned
                console.log(textStatus); // Success
                console.log(jqxhr.status); // 200
            }
            _this.initMap();
        });
    }


    setPin() {

        this.pin = {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
            fillColor: '#154094',
            fillOpacity: 1,
            strokeColor: '#154094',
            strokeWeight: 0,
            scale: 1.5
        };
    }


    /**
     * Enable Scrolling With Mouse Wheel
     * http://bdadam.com/blog/simple-usability-trick-for-google-maps.html
     */
    enableScrollingWithMouseWheel() {
        var _this = this;

        _this.map.setOptions({
            scrollwheel: true
        });
    }


    /**
     * Disable Scrolling With Mouse Wheel
     * http://bdadam.com/blog/simple-usability-trick-for-google-maps.html
     */
    disableScrollingWithMouseWheel() {
        var _this = this;

        _this.map.setOptions({
            scrollwheel: false
        });
    }


    // Disable Scrolling With Mouse Wheel at click outside of map
    disableScrolloutsideMap() {
        var _this = this;
        if (typeof _this.map != 'undefined') {

            $('body').on('mousedown', function (event) {

                var clickedInsideMap = $(event.target).parents('#map').length > 0;

                if (!clickedInsideMap) {
                    _this.disableScrollingWithMouseWheel();
                }
            });

            // Disable Scrolling With Mouse Wheel when scrolling
            $(window).scroll(function () {
                _this.disableScrollingWithMouseWheel();
            });

        }
    }


    // Add an info window on click: add the address as the info content
    addInfoWindow(marker, contentString) {
        var _this = this;

        google.maps.event.addListener(marker, 'click', function () {
            if (!_this.infowindow) {
                _this.infowindow = new google.maps.InfoWindow();
            }
            //Setting content of infowindow
            _this.infowindow.setContent(contentString);
            // Open infowindow
            _this.infowindow.open(map, marker);
        });
    }


    // Opens the info window of the marker without event and while start
    showInfoWindowWithoutEvent(marker, contentString) {
        var _this = this;

        if (!_this.infowindow) {
            _this.infowindow = new google.maps.InfoWindow();
        }
        //Setting content of infowindow
        _this.infowindow.setContent(contentString);
        // Open infowindow
        _this.infowindow.open(map, marker);
    };


    attachtToContainer(container) {
        this.$plugin.appendTo(container);
    }


    removeContainer(container) {
        container.remove();
    }

    /**
     * Hide map by adding class u-hide
     */
    disable() {
        if(!this.$plugin.parent().hasClass("u-hide")) {
            this.$plugin.parent().addClass("u-hide");
        }
    }

    /**
     * Show map by removing class u-hide
     */
    enable() {
        if(this.$plugin.parent().hasClass("u-hide")) {
            this.$plugin.parent().removeClass("u-hide");
        }
    }


    getGoogleRoute() {
        var googleMapsAdress = this.$config['street'] + '+' + this.$config['city'] + '+' + this.$config['postalcode'];
        var googleMapsAdressURIEncoded = encodeURI(googleMapsAdress);
        return '<a class="c-more-link" href="https://www.google.com/maps/dir/?api=1&destination=' + googleMapsAdressURIEncoded + '">' + this.$config['routeLLL'] + '</a>';
    }
}